import PhoneLoginView from '@Views/PhoneLoginView.vue';
import PhoneVerificationEntryView from '@Views/PhoneVerificationEntryView.vue';
import VerifyPasscodeView from '@Views/VerifyPasscodeView.vue';
import MaxAttempts from '@Views/MaxAttempts.vue';
import VerifyIdentityView from '@Views/VerifyIdentityView.vue';
import UnableToProcess from '@Views/UnableToProcess.vue';
import InstructionView from '@Views/idv/InstructionView.vue';
import DocTypeView from '@Views/idv/DocTypeView.vue';
import PauseView from '@Views/PauseView.vue';
import Processing from '@Views/idv/Processing.vue';
import IdvComplete from '@Views/idv/IdvComplete.vue';
import DeviceVerificationView from '@Views/DeviceVerificationView.vue';
import AccessDeniedView from '@Views/AccessDeniedView.vue';
import DeviceThrottledView from '@Views/DeviceThrottledView.vue';
import GeneralErrorView from '@Views/GeneralErrorView.vue';
import SelectAccountView from '@Views/SelectAccountView.vue';
import VerifyEmailCodeView from '@Views/VerifyEmailCodeView.vue';
import MfaFailedView from '@Views/MfaFailedView.vue';
import ChannelSelectionView from '@Views/ChannelSelectionView.vue';
import KbaPrimerView from '@Views/kba/KbaPrimerView.vue';
import KbaPersonalDetailsView from '@Views/kba/KbaPersonalDetailsView.vue';
import KbaQuestionsView from '@Views/kba/KbaQuestionsView.vue';
import IdentityUnverified from '@Views/IdentityUnverified.vue';
import PermissionDeniedView from '@Views/idv/PermissionDeniedView.vue';
import IdvEndedView from '@Views/idv/IdvEndedView.vue';
import DisableVpnView from '@Views/DisableVpnView.vue';

export const createRoutes = (basePath: string) => {
    return [
        {
            path: `${basePath}/auth`,
            name: 'bootstrap'
        },
        {
            path: `${basePath}/auth/phone`,
            name: 'enter-phone',
            component: PhoneLoginView
        },
        {
            path: `${basePath}/auth/vpc`,
            name: 'verify-passcode',
            component: VerifyPasscodeView
        },
        {
            path: `${basePath}/auth/verify-phone`,
            name: 'verify-phone',
            component: PhoneVerificationEntryView
        },
        {
            path: `${basePath}/auth/mfa-failed`,
            name: 'mfa-failed',
            component: MfaFailedView
        },
        {
            path: `${basePath}/auth/disabled`,
            name: 'auth-disabled',
            component: MaxAttempts
        },
        {
            // The KYC step-up is the only auth screen that offers "Back to Dashboard".
            // It is always the last step of any flow it appears in, so the shared
            // BackToDashboard inference already treats it as terminal; recording that
            // here keeps the CTA if the flow-store inference is ever removed. Every
            // other auth view opts out via the layout's suppress-back-to-dashboard.
            path: `${basePath}/auth/verify-identity`,
            name: 'verify-identity',
            component: VerifyIdentityView,
            meta: { terminal: true },
        },
        {

            path: `${basePath}/auth/unable-to-process`,
            name: 'unable-to-process',
            component: UnableToProcess
        },
        {
            // This will pause the process for the Client user until it is manually reviewed
            path: `${basePath}/auth/pause`,
            name: 'pause',
            component: PauseView
        },
        {
            path: `${basePath}/auth/verify-identity-instructions`,
            name: 'verify-identity-instructions',
            component: InstructionView,
            meta: { requiresClientIdInQuery: true },
        },
        {
            path: `${basePath}/auth/identity-doc-type`,
            name: 'identity-doc-type',
            component: DocTypeView,
            meta: { requiresClientIdInQuery: true },
        },
        {
            path: `${basePath}/auth/identity-processing`,
            name: 'identity-processing',
            component: Processing
        },
        {
            path: `${basePath}/auth/identity-complete`,
            name: 'identity-complete',
            component: IdvComplete
        },
        {
            path: `${basePath}/auth/idv-permission-denied`,
            name: 'idv-permission-denied',
            component: PermissionDeniedView,
        },
        {
            path: `${basePath}/auth/idv-ended`,
            name: 'idv-ended',
            component: IdvEndedView,
        },
        {
            path: `${basePath}/auth/verify-device`,
            name: 'verify-device',
            component: DeviceVerificationView
        },
        {
            path: `${basePath}/auth/access-denied`,
            name: 'access-denied',
            component: AccessDeniedView
        },
        {
            path: `${basePath}/auth/device-throttled`,
            name: 'device-throttled',
            component: DeviceThrottledView
        },
        {
            path: `${basePath}/auth/error`,
            name: 'general-error',
            component: GeneralErrorView
        },
        {
            path: `${basePath}/auth/select-account`,
            name: 'select-account',
            component: SelectAccountView
        },
        {
            path: `${basePath}/auth/verify-email-code`,
            name: 'verify-email-code',
            component: VerifyEmailCodeView
        },
        {
            path: `${basePath}/auth/channel-selection`,
            name: 'channel-selection',
            component: ChannelSelectionView
        },
        {
            path: `${basePath}/auth/disable-vpn`,
            name: 'disable-vpn',
            component: DisableVpnView
        },
        {
            path: `${basePath}/auth/kba-primer`,
            name: 'kba-primer',
            component: KbaPrimerView
        },
        {
            path: `${basePath}/auth/kba-details`,
            name: 'kba-details',
            component: KbaPersonalDetailsView
        },
        {
            path: `${basePath}/auth/kba-questions`,
            name: 'kba-questions',
            component: KbaQuestionsView
        },
        {
            path: `${basePath}/auth/kba-error`,
            name: 'kba-error',
            component: IdentityUnverified
        },
        {
            path: `${basePath}/auth/request-blocked`,
            name: 'request-blocked',
            component: IdentityUnverified
        }
    ];
};
